import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { useRefinementList, useInstantSearch } from 'react-instantsearch';
import { usePrevious } from 'react-use';
import BrowserOnly from 'components/consumer/BrowserOnly';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import { FABRIC_COLOR_CODES_MAP } from 'commons/constants';
import ProductListingColorFilter from './components/ProductListingColorFilter';
const DesktopProductListingColorFilter = () => {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      attribute: "option_color",
      skipSuspense: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    items: colorFilters,
    refine: refineColorFilters
  } = useRefinementList(t0);
  const {
    results
  } = useInstantSearch();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.keys(FABRIC_COLOR_CODES_MAP);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== colorFilters) {
    t2 = t1.filter(c => colorFilters.some(cf => cf.label?.toLowerCase() === c));
    $[2] = colorFilters;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const colors = t2;
  const previousColors = usePrevious(colors);
  let t3;
  if ($[4] !== colors || $[5] !== previousColors || $[6] !== results?.nbHits) {
    t3 = () => {
      if (colors.length) {
        return colors;
      }
      if (results?.nbHits === 0) {
        return [];
      }
      return previousColors ?? [];
    };
    $[4] = colors;
    $[5] = previousColors;
    $[6] = results?.nbHits;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  results?.nbHits;
  let t4;
  if ($[8] !== t3) {
    t4 = t3();
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const displayColors = t4;
  let t5;
  if ($[10] !== colorFilters || $[11] !== displayColors || $[12] !== refineColorFilters) {
    t5 = <BrowserOnly><TabletAndDesktopOnly><div className="hidden md:block"><ProductListingColorFilter colors={displayColors} colorFilters={colorFilters} refineColorFilters={refineColorFilters} /></div></TabletAndDesktopOnly></BrowserOnly>;
    $[10] = colorFilters;
    $[11] = displayColors;
    $[12] = refineColorFilters;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default DesktopProductListingColorFilter;